import { render, staticRenderFns } from "./PremiumLawyerOfficeRow.vue?vue&type=template&id=0a8d8c86"
import script from "./PremiumLawyerOfficeRow.vue?vue&type=script&lang=js"
export * from "./PremiumLawyerOfficeRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports